import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Live updates for a running release (text/event-stream, not JSON). Emits a bare
 * `event: changed` whenever run-sync writes the release's workflow runs; the
 * client then refetches getRelease. Heartbeat comments keep proxies from idling out.
 */
export const releaseEventsStream = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/events',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.undefined(),
});
